import { useEffect, useRef } from 'react'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { AppError } from '@shared/api/error'
import { toast } from '@shared/lib/toast/toast-store'
import { useConsumeMemberMagic } from '../api/member-access.queries'
import { useMemberSession } from '../model/member-session-store'
import { MemberAccessLayout } from './MemberAccessLayout'
import { loginPanel, subtitle, title } from './member-access.css'

export function MemberMagicLinkPage({ producerId }: { producerId: string }) {
  const navigate = useNavigate()
  const search = useSearch({ strict: false })
  const setSession = useMemberSession((state) => state.setSession)
  const consume = useConsumeMemberMagic()
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    const token = search.token
    if (!token) {
      void navigate({ to: '/acesso/$producerId', params: { producerId } })
      return
    }
    started.current = true
    void consume
      .mutateAsync({ producerId, token })
      .then((session) => {
        setSession(session.token, session.member, session.producerName)
        void navigate({ to: '/acesso/$producerId/biblioteca', params: { producerId } })
      })
      .catch((error: unknown) => {
        toast.error({
          title: 'Link invalido',
          description: error instanceof AppError ? error.message : 'Peca um novo envio.',
        })
        void navigate({ to: '/acesso/$producerId', params: { producerId } })
      })
  }, [consume, navigate, producerId, search.token, setSession])

  return (
    <MemberAccessLayout producerName="Area de membros">
      <section className={loginPanel}>
        <h1 className={title}>Entrando</h1>
        <p className={subtitle}>Validando seu acesso...</p>
      </section>
    </MemberAccessLayout>
  )
}
